import React from "react";
import { connect } from "react-redux";
import { getRecibosPorUsuario, publicarLote } from "./RecibosService";
import "../../styles/Empresa.css";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import Navbar from "../home/Navbar";
import { Link, useLocation } from "react-router-dom";
import visibility from "../../styles/icons/visibility.svg";
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";
import ComponenteVacio from "../componentes/avisos/ComponenteVacio";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";
import { getTramites, eliminarTramite } from "../tramites/TramitesService.js";
import { swipeActions } from "../../assets/js/scripts/swipeActions";

class RecibosPendientes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Ingrese Pin de Firma",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedRecibo: {
        recibo: "",
        fechaCarga: "",
        empleado: "",
        estado: "",
        estadoMTESS: false,
      },
      documento: {},
      idTramite: "",
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      dialogPinOpen: false,
      open: false,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      severityFlash: "",
      recibos: [],
      page: 0,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      search: "",
      loading: true,
      eliminarDocumento: false,
    };
    localStorage.setItem("urlRaiz", window.location.href);
    this.tableRef = React.createRef();
  }

  handleDialog = (value) => {
    this.setState({
      dialogIsOpen: value,
    });
  };

  handleDialogPin = (value, mensaje = "", severity = "") => {
    this.setState({
      dialogPinOpen: value,
      mostrarMensajeFlash: true,
      mensajeFlash: mensaje,
      severityFlash: severity,
    });
  };
  handleClose = (value) => {
    this.setState({
      open: value,
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };
  handlePageSizeChange(event) {
    const pageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize, page: 0 }, () => {
      this.fetchRecibos();
    });
  }
  abrirModalEliminar = (estado, documento = null) => {
    this.setState({
      eliminarDocumento: estado,
      documento: documento,
    });
  };

  cerrarModalEliminar = () => {
    this.setState({ eliminarDocumento: false });
  };

  handleDelete = () => {
    this.setState({
      openPantallaCarga: true,
      eliminarDocumento: false,
    });
    eliminarTramite(this.state.documento.idTramite).then((res) => {
      this.setState({
        openPantallaCarga: false,
        open: false,
        mostrarMensajeFlash: true,
        mensajeFlash: res.mensaje,
        severityFlash: !res.error ? "success" : "danger",
      });
      this.fetchRecibos(this.state.page, this.state.pageSize, "");
    });
  };
  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(newPage, this.state.pageSize, "");
      });
    }
  }
  componentDidMount() {
    this.fetchRecibos(0, this.state.pageSize, "");
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.recibosData.recibos !== this.props.recibosData.recibos &&
      this.props.recibosData.recibos.length > 0
    ) {
      requestAnimationFrame(() => {
        swipeActions();
      });
    }
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchRecibos(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">
              {i + 1}
            </a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">
              1
            </a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">
              {i + 1}
            </a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">
              {totalPages}
            </a>
          </li>
        );
      }
    }

    return pages;
  }

  fetchRecibos(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getRecibosPorUsuario(page, pageSize, search, false).then(() => {
      this.setState({
        recibos: this.props.recibosData.recibos,
        page: this.props.recibosData.page,
        totalCount: this.props.recibosData.totalCount,
        totalPages: Math.ceil(this.props.recibosData.totalCount / pageSize),
        loading: false,
      });
    });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchRecibos(0, this.state.pageSize, this.state.search);
    });
  };

  renderizarComponenteConElementos = () => {
    return (
      <div>
        <ModalEliminarConDetalles
          isOpen={this.state.eliminarDocumento}
          titulo="Documento"
          elemento={this.state.documento}
          onConfirmar={this.handleDelete}
          cerrarModal={this.cerrarModalEliminar}
          onResultado={this.manejarResultado}
          onError={this.manejarError}
          detallesAMostrar={[
            { clave: "conceptoONombre", etiqueta: "Nombre del documento" },
            { clave: "formato", etiqueta: "Formato" },
          ]}
          mensaje="Esta acción eliminará permanentemente el documento"
          textoBotonAccion="CONFIRMAR ELIMINACIÓN"
        />
        <MensajeFlash
          mensaje={this.state.mensajeFlash}
          severity={this.state.severityFlash}
          open={this.state.mostrarMensajeFlash}
          handleClose={this.handleCloseMensajeFlash}
        />
        <div className="component-pagination">
          <h5 className="list-title">Documentos Pendientes</h5>
          <div className="pagination-actions">
            {/* Buscador */}
            <form className="search-form form">
              <div className="search-group">
                <div className="input-icon">
                  <span className="material-symbols-outlined">search</span>
                </div>
                <input
                  type="search"
                  className="input-search"
                  placeholder="Buscar.."
                  aria-label="Search"
                  value={this.state.search}
                  onChange={this.handleSearchChange}
                />
              </div>
            </form>

            {/* Paginador */}
            <div className="pagination">
              <span className="info-pages">
                {this.state.page * this.state.pageSize + 1}-
                {Math.min(
                  (this.state.page + 1) * this.state.pageSize,
                  this.state.totalCount
                )}{" "}
                de {this.state.totalCount}
              </span>

              <button
                className={`btn-prev ${this.state.page === 0 ? "btn-disabled" : ""
                  }`}
                onClick={() => this.handlePageChange(this.state.page - 1)}
                disabled={this.state.page === 0}
              >
                <span className="material-symbols-outlined">navigate_before</span>
              </button>

              <button
                className={`btn-next ${this.state.page === this.state.totalPages - 1
                  ? "btn-disabled"
                  : ""
                  }`}
                onClick={() => this.handlePageChange(this.state.page + 1)}
                disabled={this.state.page === this.state.totalPages - 1}
              >
                <span className="material-symbols-outlined">navigate_next</span>
              </button>
            </div>
          </div>
        </div>
        <div>
          {this.state.loading ? (
            <div className="d-flex justify-content-center p-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Cargando...</span>
              </Spinner>
            </div>
          ) : (
            <div className="component-lista-documentos">
              <div className="component-container">
                {this.props.recibosData.recibos.map((recibo, index) => (
                  <div key={index} className="list-item item-pending">
                    {recibo.tipo === "TRAMITE" ? (
                      <>
                        <Link
                          to={{
                            pathname:
                              "/tramites/firma/false/" + recibo.idTramite,
                            state: {
                              nombre: recibo.nombre,
                              fechaCarga: recibo.fechaCarga,
                            },
                          }}
                          className="list-item__link"
                        >
                          <div className="item-info">
                            <div className="item-copy">
                              <span className="copy__uppertitle">
                                {recibo.empresa}
                              </span>
                              <h3 className="copy__title">
                                {recibo.conceptoONombre}
                              </h3>
                              <p className="copy__description">
                                {recibo.tipoDocumento}
                              </p>
                            </div>
                          </div>
                          <div className="item-elements">
                            <div className="item__status">
                              <span className="label__info">{recibo.estado}</span>
                            </div>
                            <time
                              className="item__date"
                              dateTime={recibo.fechaImportacion}
                            >
                              {new Date(recibo.fecha).toLocaleDateString("es-ES", {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                              })}
                            </time>
                          </div>
                        </Link>
                        {recibo.esMio && (
                          <div className="item-actions">
                            <a
                              onClick={() =>
                                this.abrirModalEliminar(true, recibo)
                              }
                              className="btn-small btn-primary-tonal btn-circle-icon"
                            >
                              <span className="material-symbols-outlined">
                                delete
                              </span>
                              <span className="mobile-txt">Eliminar</span>
                            </a>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <Link
                          to={{
                            pathname:
                              `/bandeja/recibo/view/Pendientes/${recibo.idLote}/${recibo.idRecibo}`,
                            state: { recibo },
                          }}
                          className="list-item__link"
                        >
                          <div className="item-info">
                            <div className="item-copy">
                              <span className="copy__uppertitle">
                                {recibo.empresa}
                              </span>
                              <h3 className="copy__title">
                                {recibo.conceptoONombre}
                              </h3>
                              <p className="copy__description">
                                {recibo.tipoDocumento}
                              </p>
                            </div>
                          </div>
                          <div className="item-elements">
                            <div className="item__status">
                              <span className="label__info">{recibo.estado}</span>
                            </div>
                            <time
                              className="item__date"
                              dateTime={recibo.fechaImportacion}
                            >
                              {new Date(recibo.fecha).toLocaleDateString("es-ES", {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                              })}
                            </time>
                          </div>
                        </Link>
{/*                         <div className="item-actions">
                          <a
                            onClick={() =>
                              this.abrirModalEliminar(true, recibo)
                            }
                            className="btn-small btn-primary-tonal btn-circle-icon"
                          >
                            <span className="material-symbols-outlined">
                              delete
                            </span>
                            <span className="mobile-txt">Eliminar</span>
                          </a>

                        </div> */}
                      </>

                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  renderizarComponenteSinElementos = () => {
    return (
      <div>
        <div className="component-pagination">
          <h5 className="list-title">Documentos Pendientes</h5>
        </div>
        <ComponenteVacio />
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.state.recibos.length > 0
          ? this.renderizarComponenteConElementos()
          : this.renderizarComponenteSinElementos()}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getRecibosPorUsuario: (page, size, search) =>
    dispatch(getRecibosPorUsuario(page, size, search, false)),
});

const mapStateToProps = (state) => ({
  recibosData: state.recibosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(RecibosPendientes);
